import React, { useState } from 'react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "1. What is LinkedIn Local Cameroon?",
      answer: "LinkedIn Local Cameroon is a professional networking event that brings your LinkedIn connections offline by creating opportunities for professionals, entrepreneurs, students, recruiters, and leaders to meet, connect, learn and collaborate in person."
    },
    {
      question: "2. When and where will LinkedIn Local Cameroon 2026 take place?",
      answer: "LinkedIn Local Cameroon 2026 will take place on 10th October 2026 at Best Western Hotel, Soaho Douala Airport Hotel, Douala, Cameroon."
    },
    {
      question: "3. What is the theme of LinkedIn Local Cameroon 2026?",
      answer: "The theme for this edition is: “Rise Locally. Lead Globally.”\nThe goal is to position Cameroonian talents, professionals, and businesses for global opportunities."
    },
    {
      question: "4. Who can attend LinkedIn Local Cameroon?",
      answer: "The event is open to:\n\n* Entrepreneurs\n* Business leaders\n* Professionals\n* Students\n* Job seekers\n* Recruiters\n* HR professionals\n* Content creators\n* Investors\n* Anyone interested in professional growth and networking"
    },
    {
      question: "5. How can I register for LinkedIn Local Cameroon?",
      answer: "📌 You can register directly through our website. Select your preferred ticket category, complete the registration process and receive your confirmation details.\n\n📌Then, reach out to this Number +237 683 66 85 18/ +237 6 55 87 69 97 on WhatsApp with proof of payment to be added to the MAIN LLC community group for follow-up, updates and for your delegate flyer to be designed."
    },
    {
      question: "6. How much is the ticket?",
      answer: "Ticket prices vary depending on the category selected. Please visit the registration page to see available ticket options and benefits."
    },
    {
      question: "7. What does my ticket include?",
      answer: "**Regular Ticket: 15,000 frs (Late Registration)**\n10,000 frs (33% OFF) Early Bird ends 31st August 2026\n\nBenefits:\n- Access to the event, networking sessions, panel discussions, keynote sessions, and opportunities to connect with professionals, leaders, and potential partners.\n- Regular Delegate flyer\n- Certificate of Participation (Soft copy)\n- Access to event community group before and after the event\n- Refreshment\n\n**VIP Ticket: 50,000 frs (Late Registration)**\n35,000 frs (30% OFF) Early Bird ends 31st August 2026\n\nBenefits:\n- VIP Fast Track Entry\n- Reserved VIP priority seating row\n- Complimentary refreshments in the VIP area\n- VIP Delegate flyer\n- Access to event community group before and after the event\n- Certificate of participation (Hard Copy)\n- Exclusive access to a 2-week Post Event LinkedIn Career Accelerator Program"
    },
    {
      question: "8. Can I buy tickets for someone else?",
      answer: "Yes. You can purchase tickets on behalf of another person. Make sure to provide the correct attendee details during registration."
    },
    {
      question: "9. Can I get a refund after purchasing my ticket?",
      answer: "Tickets are not subject to a refund policy."
    },
    {
      question: "10. Will I receive a confirmation after registration?",
      answer: "Yes. After completing your registration, you will receive a confirmation message/email with your ticket details."
    },
    {
      question: "11. I registered but did not receive my ticket. What should I do?",
      answer: "Please check your email spam/junk folder. If you still cannot find it.\n\nOr contact our support team on WhatsApp (+237 683 66 85 18/ +237 6 55 87 69 97) with your registration details."
    },
    {
      question: "12. Can companies attend the event?",
      answer: "Absolutely. Companies can attend to connect with talents, strengthen their employer brand, discover opportunities, and engage with professionals across different industries."
    },
    {
      question: "13. Are there sponsorship opportunities available?",
      answer: "Yes. We have partnership and sponsorship opportunities available for organizations that want to increase their visibility, connect with professionals, and support this movement.\n\nReach out here for partnership & Sponsorship\n👉👉 +237 683 66 85 18 / +237 6 80 19 20 95"
    },
    {
      question: "14. How can my organization become a partner?",
      answer: "You can contact our partnership team through the website or request our sponsorship package."
    },
    {
      question: "15. Will there be networking opportunities?",
      answer: "Yes. Networking is at the heart of LinkedIn Local Cameroon. The event is designed to help attendees build meaningful professional relationships."
    },
    {
      question: "16. Will there be speakers at the event?",
      answer: "Yes. LinkedIn Local Cameroon will feature industry leaders, entrepreneurs, recruiters, and professionals who will share insights on career growth, business, branding, recruitment, and visibility."
    },
    {
      question: "17. What topics will be discussed?",
      answer: "Topics include:\n\n* Preparing for a Global Workforce\n* Recruitment & Talent Acquisition\n* Employer Branding\n* Personal Branding\n* Social Selling & Business Growth\n* LinkedIn Advertising & Visibility Strategies\n* Strategic Networking, etc"
    },
    {
      question: "18. How can I contact the LinkedIn Local Cameroon team?",
      answer: "You can reach our team through the contact information provided below or on our website.\n\n+237 683 66 85 18\n+237 6 80 19 20 95\n+237 6 55 87 69 97"
    },
    {
      question: "19. Why should I attend LinkedIn Local Cameroon?",
      answer: "Because opportunities are created through relationships. LinkedIn Local Cameroon gives you the opportunity to meet 1000+ professionals, discover opportunities, learn from industry leaders and build connections that can transform your career or business.\n\nYOU DO NOT HAVE TO MISS THIS EVENT FOR ANYTHING!\nREGISTER NOW BEFORE ALL TICKETS ARE SOLD OUT"
    }
  ];

  return (
    <section className="section" style={{ background: 'var(--gray-bg)' }}>
      <div className="container" style={{ maxWidth: 800 }}>
        <div className="text-center mb-12">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-body">
            Find answers to common questions about the LinkedIn Local Cameroon event.
          </p>
        </div>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
              style={{
                border: '1px solid var(--gray-line)',
                borderRadius: 'var(--radius)',
                marginBottom: '16px',
                background: '#fff',
                overflow: 'hidden'
              }}
            >
              <div 
                className="faq-question" 
                onClick={() => toggleFaq(index)}
                style={{
                  padding: '20px',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  fontWeight: '700',
                  color: openIndex === index ? 'var(--blue)' : 'var(--text-dark)',
                  transition: 'all 0.2s'
                }}
              >
                <span style={{ fontFamily: 'Montserrat', fontSize: '15px' }}>{faq.question}</span>
                <svg 
                  width="24" height="24" viewBox="0 0 24 24" 
                  style={{
                    transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0)',
                    transition: 'transform 0.3s'
                  }}
                >
                  <path d="M7 10l5 5 5-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div 
                className="faq-answer"
                style={{
                  maxHeight: openIndex === index ? '500px' : '0',
                  padding: openIndex === index ? '0 20px 20px' : '0 20px',
                  opacity: openIndex === index ? 1 : 0,
                  transition: 'all 0.3s ease-in-out',
                  color: 'var(--text-body)',
                  fontSize: '14px',
                  lineHeight: '1.6',
                  whiteSpace: 'pre-wrap'
                }}
              >
                {faq.answer}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
